module.exports = __webpack_public_path__ + "../resources/images/illustration_drink-514135d9e03ff80f4ab8c253501846d5.svg";